<template>
  <div class="project-sales-report" v-if="project">
    <b-row class="mt-4" v-if="showToGuest('salesReport', guestVisibleSections)">
      <b-col lg="12" md="12" sm="12">
        <legend>
          <strong>{{ $t('salesReport') }}: {{ $t('collected_data') }}</strong>
        </legend>
        <MobileProjectsSalesReport :project="project" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MobileProjectsSalesReport from './MobileProjectsSalesReport.vue';
import { canWriteField, showToGuest } from '@/helpers/userCapabilities';

export default {
  components: {
    MobileProjectsSalesReport,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      attachmentType: 'salesReportAttachments',
      guestVisibleSections: {
        salesReport: true,
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isGuest']),
  },
  methods: {
    /**
     * Bubble up AttachmentList delete event
     */
    onDeleteAttachment(event) {
      this.$emit('project-report-attachment-list:delete', {
        attachmentId: event.attachmentId,
        attachmentType: this.attachmentType,
      });
    },
    canWriteField,
    showToGuest,
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.verification-flex {
  display: flex;
  gap: 1em;
  flex-flow: row wrap;
  flex-basis: 100%;
  justify-content: flex-start;
}

.verification-flex > div {
  flex: 1;
  min-width: 300px;
}
</style>
